<template>
    <div class="datatable">
        <form class="search-products">
            <input type="text" name="lists" v-model="searchLists" placeholder="Search by lists">
            <button class="green-btn" @click="searchByLists()"><font-awesome-icon icon="search" /></button>
        </form>
        <p>({{ count }} product{{ count > 1 ? "s" : ""}})</p>
        <Pagination :currentPage=page :pageCount=totalPages @goToPage="goToPage" />
        <div class="lists">
            <ul class="styledList">
                <li v-for="l of lists" :key="l" @click="addSearchList(l)">{{ l }}</li>
            </ul>
        </div>
        <table>
            <thead>
            <tr>
                <th></th>
                <th>Name</th>
                <th>Brand</th>
                <th>Lists</th>
                <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item of products" :key="item._id">
                <td><div class="data-img"><img v-lazy="img + '/' + item.mainPicture"></div></td>
                <td><h3>{{ item.ean.substring(0, 20) }}...</h3></td>
                <td><span v-if="item.productId">{{ item.productId.brand ? item.productId.brand.name : "" }}</span></td>
                <td><p>{{ item.list }}</p></td>
                <td>
                    <div class="actions">
                        <button class="green-btn" @click="removeProduct(item._id)"><font-awesome-icon icon="times" /></button>
                        <router-link :to="{ name: 'admin_products_variant', params: { id: item._id }}" class="green-btn"><font-awesome-icon icon="pen" /></router-link>
                        <a class="green-btn" @click="duplicateThisVariant(item._id)"><font-awesome-icon icon="copy" /></a>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <Pagination :currentPage=page :pageCount=totalPages @goToPage="goToPage" />
        <p>{{ qte }}/{{ count }} products</p>
    </div>
</template>

<script>
    import { IMG } from '@/constants';
    import {mapActions, mapGetters} from "vuex";
    import Pagination from "@/components/Pagination";
    import Swal from "sweetalert2";
    /*
    Valeur non importé :
    variantNb: 0,
    */

    export default {
        name: "Admin",
        components: {
            Pagination
        },
        created() {
            if (this.$route.query.lists) {
                this.searchLists = this.$route.query.lists;
            }
            this.getPage({adminList: this.searchLists, qte: 100, page: this.page});
            this.getAllLists()
        },
        data(){
            return{
                searchLists: "",
                listParams: this.$route.query.lists || "",
                page: parseInt(this.$route.query.page + '') || 1,
                img: IMG
            }
        },
        methods: {
            ...mapActions('product', [
                'getPage',
                'getAllLists',
                'deleteVariant',
                'duplicateVariant'
            ]),

            addSearchList(name) {
                this.searchLists += " " + name;
            },

            searchByLists(){
                this.$router.push({ name: "admin_products", query: { lists: this.searchLists, page: this.page }})
                this.getPage({adminList: "",qte: 100, page: this.page});
            },

            goToPage(page) {
                this.page = page;
                this.searchByLists();
            },

            removeProduct(id){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.deleteVariant(id)
                            .then(() => {
                                Swal.fire(
                                    'Deleted!',
                                    'The product have been deleted',
                                    'success'
                                )
                            });
                    }
                })
            },

            duplicateThisVariant(id) {
                this.duplicateVariant(id).then(data => {
                    this.$router.push({ name: 'admin_products_variant', params: { id: data.data.product._id }});
                })
            },
        },
        computed:{
            ...mapGetters('product', [
                'lists',
                'products',
                'count',
                'qte',
                'totalPages'
            ]),

        },
    }
</script>

<style scoped lang="scss">

        form {
        margin-bottom: 20px;
        padding: 10px;
        display: flex;
        justify-content: center;

        input {
            font-size: 13px;
            display: inline-block;
            width: 200px;
            height: 40px;
            margin: initial;
            border: 1px solid var(--main-green);
            padding-left: 5px;
            border-radius: 5px 0 0 5px;
            box-sizing: border-box;
        }

        .green-btn{
            border-radius: 0 5px 5px 0;
        }
    }

    .lists {
        background-color: var(--main-green);
        margin-bottom: 50px;
        border: 1px solid var(--main-green);
        border-radius: 5px;
        overflow: hidden;

        ul {
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            height: 30px;
            padding: 10px 20px;
            transition-duration: .3s;
            overflow: hidden;

            &:hover{
                height: auto;
            }
        }
    }

    td{
        &:first-child {
            text-align: left;
        }

        .data-img {
            display: flex;
            justify-content: center;
            width: 100px;
            height: 100px;
            margin: 10px;
            border: 1px solid var(--light-green);
            border-radius: 50px;
            background-color: #fff;
            overflow: hidden;

            img{
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }

        .actions {

            .green-btn{
                font-size: 10px;
                width: 30px;
                height: 30px;
                border-radius: 50%;

                &:first-child {
                    background-color: var(--danger);
                }
            }
        }
    }

</style>
